import { EXECUTE_RESTART_PAYMENT_PACKAGE } from "..";
import { apiInstance } from "../config/apiInstance";

export type ExecuteRestartPaymentPackageRequest = {
  consecutive: string;
  code: string;
};

export const executeRestartPaymentPackage = async (
  data: ExecuteRestartPaymentPackageRequest,
): Promise<string> => {
  const response = await apiInstance.post<string>(
    EXECUTE_RESTART_PAYMENT_PACKAGE,
    data,
  );
  return response.data;
};
